<template>
  <div class="honor" id="honor">
    <el-row>
      <el-col class="honor_left">
        <h2>企业荣誉</h2>
        <p class="underline"></p>
        <p class="honor-p">Enterprise honor</p>
      </el-col>
      <el-col class="honor-right">
        <el-row :gutter="1">
          <el-col :span="6" v-for="(item, index) in lists" :key="'honor-'+index">
            <div class="grid-content" :style="{ background: 'url('+item.background+')', backgroundSize: '100% 100%' }"></div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
const honorListUri = "website/index/honor/get/all";

export default {
  data() {
    return {
      lists: []
    };
  },
  created() {
    this.getHonorList();
  },
  methods: {
    getHonorList() {
      this.$api.get(honorListUri).then(res => {
        // console.log(res);
        this.lists = res.list.slice(0, 8);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.honor {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  margin-top: 36px;

  & > .el-row {
    display: flex;
    align-items: center;

    .honor_left {
      width: 332px;
      padding: 48px;
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 41px;
      }
      .honor-p {
        font-size: 24px;
        color: #999999;
      }
    }
    .honor-right {
      flex: 1;
      .el-row {
        .el-col {
          margin-bottom: 1px;
          .grid-content {
            height: 216px;
          }
        }
      }
    }
  }
}
</style>


